<form class="ship-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput
      [formControl]="myControl" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let ship of filteredShips | async" [value]="ship" 
      [matTooltip]="ship?.eni || ''">
        {{ship?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-mini-fab *ngIf="displayAddButton" type="button" style="margin-left: 10px;" (click)="createShip()" [matTooltip]="'label.add-entry' | translate">
    <mat-icon>add</mat-icon>
  </button>
</form>

<!-- <form class="ship-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let ship of ships" [value]="ship">
        {{ship?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->